import { render, staticRenderFns } from "./SsamTalkWriteStepLayout.vue?vue&type=template&id=37793cbd&scoped=true"
import script from "./SsamTalkWriteStepLayout.vue?vue&type=script&lang=js"
export * from "./SsamTalkWriteStepLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37793cbd",
  null
  
)

export default component.exports